export const registerServiceWorker = async (): Promise<void> => {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  const url = '/sw.js?v=4';

  // unregisters old scripts
  const registrations = await navigator.serviceWorker.getRegistrations();

  registrations.forEach((registration) => {
    const scriptUrl = registration.active?.scriptURL || '';
    if (scriptUrl.includes(url)) {
      return;
    }

    registration.unregister();
  });

  navigator.serviceWorker.register(url);
};
